<template>
  <div>
    <label class="mt-1">Widget Type:</label><cbs-reference-picker-sid
      entitysid="widgettype"
      :value-container="value"
      value-name="widgettype"
    />

    <div v-if="!isHabit">
      <label class="mt-1">Chart Type:</label><b-form-input
        v-model="value.charttype"
        placeholder="Input chart type"
      />
    </div>
    <label class="mt-1">Title:</label><b-form-input
      v-model="value.title"
      placeholder="Input title"
    />
    <div v-if="isHabit">
      <label class="mt-1">Subtitle:</label><b-form-input
        v-model="value.subtitle"
        placeholder="Подзаголовок (training / health / last 7 days)"
      />
    </div>
    <div v-if="!isHabit">
      <label class="mt-1">Icon:</label><b-form-input
        v-model="value.icon"
        placeholder="Input icon"
      />
      <label class="mt-1">Color:</label><b-form-input
        v-model="value.color"
        placeholder="Input color"
      />
      <label class="mt-1">Metric:</label><b-form-input
        v-model="value.metric"
        placeholder="Input metric"
      />
      <label class="mt-1">Source Object:</label><cbs-reference-picker-sid
        entitysid="object"
        :value-container="value"
        value-name="srcobject"
      />
      <label class="mt-1">Entity:</label><cbs-reference-picker-sid
        entitysid="entity"
        :value-container="value"
        value-name="srcentity"
      />
      <label class="mt-1">Value Entity:</label><cbs-reference-picker-sid
        entitysid="entity"
        :value-container="value"
        value-name="valueentity"
      />
      <label class="mt-1">Value Format:</label><b-form-input
        v-model="value.valueformat"
        placeholder="Input value format"
      />
      <label class="mt-1">Value Round:</label><b-form-input
        v-model="value.valueround"
        placeholder="Value round"
      />
      <label class="mt-1">Category Entity:</label><cbs-reference-picker-sid
        entitysid="entity"
        :value-container="value"
        value-name="categoryentity"
      />
      <label class="mt-1">Category Format:</label><b-form-input
        v-model="value.categoryformat"
        placeholder="Input category format"
      />
      <label class="mt-1">Stack Entity:</label><cbs-reference-picker-sid
        entitysid="entity"
        :value-container="value"
        value-name="stackentity"
      />
      <label class="mt-1">Scalar:</label><cbs-reference-picker-sid
        entitysid="scalar"
        :value-container="value"
        value-name="scalar"
      />
      <label class="mt-1">Koef:</label><b-form-input
        v-model="value.koef"
        placeholder="Input koef"
        type="number"
        :formatter="formatter"
      />
    </div>

    <!-- Настройки habits-виджетов: набор полей зависит от типа -->
    <div v-if="isHabit">
      <div
        v-if="has('days')"
      >
        <label class="mt-1">Days (период, дней):</label><b-form-input
          v-model="value.days"
          type="number"
          :formatter="formatter"
          placeholder="7 / 30"
        />
      </div>
      <div v-if="has('cols')">
        <label class="mt-1">Grid columns (ячеек в строке):</label><b-form-input
          v-model="value.cols"
          type="number"
          :formatter="formatter"
          placeholder="10"
        />
      </div>
      <div v-if="has('steps')">
        <label class="mt-1">Steps (кнопки +N, через запятую):</label><b-form-input
          :value="stepsText"
          placeholder="1, 5, 10"
          @input="onSteps"
        />
      </div>
      <div v-if="has('mode')">
        <label class="mt-1">Mode (preview / active / hidden):</label><b-form-input
          v-model="value.mode"
          placeholder="preview"
        />
        <label class="mt-1">Badge:</label><b-form-input
          v-model="value.badge"
          placeholder="скоро / включён"
        />
        <label class="mt-1">Coach title:</label><b-form-input
          v-model="value.coachtitle"
          placeholder="План на сегодня"
        />
        <label class="mt-1">Coach body:</label><b-form-textarea
          v-model="value.coachbody"
          rows="3"
        />
        <b-form-checkbox
          v-model="value.showactions"
          class="mt-1"
        >Показывать кнопки действий</b-form-checkbox>
      </div>
      <div v-if="has('showstreak')">
        <b-form-checkbox
          v-model="value.showstreak"
          class="mt-1"
        >Показывать серию (streak)</b-form-checkbox>
        <label class="mt-1">Streak window (дней):</label><b-form-input
          v-model="value.streakdays"
          type="number"
          :formatter="formatter"
          placeholder="60"
        />
      </div>
      <div v-if="has('showlegend')">
        <b-form-checkbox
          v-model="value.showlegend"
          class="mt-1"
        >Показывать легенду зон</b-form-checkbox>
        <label class="mt-1">History (дней журнала):</label><b-form-input
          v-model="value.history"
          type="number"
          :formatter="formatter"
          placeholder="200"
        />
      </div>
      <div v-if="has('indicator')">
        <label class="mt-1">Indicator sid (weight / sugar / bp):</label><b-form-input
          :value="value.indicator ? value.indicator.sid : ''"
          placeholder="weight"
          @input="onIndicator"
        />
        <b-form-checkbox
          v-model="value.gooddown"
          class="mt-1"
        >Снижение — это хорошо (вес, сахар, давление)</b-form-checkbox>
      </div>
      <label class="mt-1">Habit object sid:</label><b-form-input
        :value="objSid('habitobject')"
        placeholder="habit"
        @input="v => onObjSid('habitobject', v)"
      />
      <label class="mt-1">Log object sid:</label><b-form-input
        :value="objSid('logobject')"
        placeholder="habitlog"
        @input="v => onObjSid('logobject', v)"
      />
      <label class="mt-1">Indicator object sid:</label><b-form-input
        :value="objSid('indicatorobject')"
        placeholder="indicator"
        @input="v => onObjSid('indicatorobject', v)"
      />
      <label class="mt-1">Measure object sid:</label><b-form-input
        :value="objSid('measureobject')"
        placeholder="measurelog"
        @input="v => onObjSid('measureobject', v)"
      />
    </div>

    <label class="mt-1">Columns:</label><b-form-input
      v-model="value.columns"
      placeholder="1..12"
      type="number"
      :formatter="formatter"
    />

    <cbs-debug :context="this" />
  </div>
</template>

<script>
import CbsReferencePickerSid from '@/cubus/components/reference/CbsReferencePickerSid.vue'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import {
  BFormInput, BFormTextarea, BFormCheckbox,
} from 'bootstrap-vue'

// какие настройки имеют смысл для какого habits-виджета
const HABIT_FIELDS = {
  habitday: ['showstreak'],
  habitcoach: ['mode'],
  habittraining: ['steps'],
  habithealth: ['showlegend'],
  habitweek: ['days'],
  habitmonth: ['days', 'cols'],
  habitchart: ['days', 'indicator'],
  habitstats: ['days'],
}

export default {
  name: 'CbsWidgetParam',
  components: {
    CbsDebug,
    CbsReferencePickerSid,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      refSrcObj: null,
      refSrcEnt: null,
    }
  },
  computed: {
    typeSid() {
      return (this.value && this.value.widgettype && this.value.widgettype.sid) || ''
    },
    isHabit() {
      return Object.prototype.hasOwnProperty.call(HABIT_FIELDS, this.typeSid)
    },
    stepsText() {
      return Array.isArray(this.value.steps) ? this.value.steps.join(', ') : ''
    },
  },
  methods: {
    formatter(value) {
      return Number(value)
    },
    has(field) {
      return (HABIT_FIELDS[this.typeSid] || []).includes(field)
    },
    onSteps(text) {
      const steps = String(text)
        .split(',')
        .map(s => parseInt(s.trim(), 10))
        .filter(n => n > 0)
      this.$set(this.value, 'steps', steps)
    },
    onIndicator(sid) {
      this.$set(this.value, 'indicator', { sid: String(sid).trim() })
    },
    objSid(key) {
      return (this.value[key] && this.value[key].sid) || ''
    },
    onObjSid(key, sid) {
      const v = String(sid).trim()
      if (v) this.$set(this.value, key, { sid: v })
      else this.$delete(this.value, key)
    },
  },
}
</script>

<style scoped>

</style>
